import { fullSendFragment } from "../graphql/sends"
import { basicSendFragment } from "../graphql/basicSendFragment"
import {
  updateKeyValueInFragment,
  addItemToFragmentList,
  removeItemFromFragmentList,
} from "../../utilities/graphql"

export function getSendFromStore({ store, sendId }) {
  const fullFrag = {
    id: `Send:${sendId}`,
    fragment: fullSendFragment,
    fragmentName: "fullSendFragment",
  }
  let send
  try {
    send = store.readFragment(fullFrag)
  } catch (err) {}
  if (send) {
    return send
  }
  const basicFrag = {
    id: `Send:${sendId}`,
    fragment: fullSendFragment,
    fragmentName: "fullSendFragment",
  }
  try {
    send = store.readFragment(basicFrag)
  } catch (err) {}
  if (send) {
    return send
  }
  return false
}

export function updateKeyValInSend({ store, sendId, key, value }) {
  updateKeyValueInFragment({
    store,
    id: `Send:${sendId}`,
    fragment: fullSendFragment,
    fragmentName: "fullSendFragment",
    key,
    value,
  })
  updateKeyValueInFragment({
    store,
    id: `Send:${sendId}`,
    fragment: basicSendFragment,
    fragmentName: "basicSendFragment",
    key,
    value,
  })
  return getSendFromStore({ store, sendId })
}

export function addItemToSendList({ store, sendId, item, key }) {
  // update fullSendFragment
  addItemToFragmentList({
    store,
    id: `Send:${sendId}`,
    fragment: fullSendFragment,
    fragmentName: "fullSendFragment",
    item,
    key,
  })
  // update basicSendFragment
  addItemToFragmentList({
    store,
    id: `Send:${sendId}`,
    fragment: basicSendFragment,
    fragmentName: "basicSendFragment",
    item,
    key,
  })
  return getSendFromStore({ store, sendId })
}

export function removeItemFromSendList({ store, sendId, itemId, key }) {
  // update fullSendFragment
  removeItemFromFragmentList({
    store,
    id: `Send:${sendId}`,
    fragment: fullSendFragment,
    fragmentName: "fullSendFragment",
    itemId,
    key,
  })
  // update basicSendFragment
  removeItemFromFragmentList({
    store,
    id: `Send:${sendId}`,
    fragment: basicSendFragment,
    fragmentName: "basicSendFragment",
    itemId,
    key,
  })
  return getSendFromStore({ store, sendId })
}

export default {
  updateKeyValInSend,
  addItemToSendList,
  removeItemFromSendList,
  getSendFromStore,
}
